import { useId } from 'react';
import { Info } from 'lucide-react';
import styles from './InfoLabel.module.css';

interface InfoLabelProps {
  content: string;
  label?: string;
  className?: string;
  align?: 'start' | 'end';
}

export default function InfoLabel({
  content,
  label = 'Info',
  className = '',
  align = 'start',
}: InfoLabelProps) {
  const tooltipId = useId();
  const showLabel = false;
  return (
    <span className={`${styles.wrapper} ${styles[align]} ${className}`}>
      <button
        type="button"
        className={styles.trigger}
        aria-describedby={tooltipId}
      >
        <Info size={12} />
        {showLabel && <span>{label}</span>}
      </button>
      <span id={tooltipId} role="tooltip" className={styles.tooltip}>
        {content}
      </span>
    </span>
  );
}
